/* eslint-disable unicorn/prefer-node-append */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';
import ReactDOM from 'react-dom';


export default (selector, component) =>  {
    const divContainer = document.createElement('div');
    const renderBox = document.querySelector(selector)
    if (renderBox) {
        renderBox.appendChild(divContainer);
        ReactDOM.render(
            component,
            divContainer,
        );
    }
}